<favorite-services *ngIf="authenticationService.userIsResident"></favorite-services>

<!--<div class="wrapper wrapper-content homeView" *ngIf="!authenticationService.userIsResident">-->
    <!--<div class="scrollingBox">-->
        <!--<h1>Hello {{accountService.user?.fullName}}</h1>-->
        <!--<news-list></news-list>-->
    <!--</div>-->
<!--</div>-->



// WEBPACK FOOTER //
// /app/src/app/views/home/home.component.html